'use client';

import Script from 'next/script';
import { getBranchConfig } from '../../utils';

export function BranchScript() {
    const config = getBranchConfig();

    if (!config.branchKey) {
        console.warn('The Branch SDK key was not found.');
        return null;
    }

    const initOptions = {
        ...(config.enableJourneys && { enable_journeys: true }),
        ...(config.debug && { debug: true }),
    };

    return (
        <Script
            id="branch-sdk"
            src={config.branchScriptUrl}
            strategy="afterInteractive"
            onLoad={() => window.branch?.init(config.branchKey, initOptions)}
        />
    );
}
